import React from "react";
import { Icon } from "@chakra-ui/react";

export const MenuCloseIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 6L18 18M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};
